import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import { useTranslate, required, useStore } from 'react-admin'
import { Grid } from '@mui/material'
import { Dialog, DialogActions, DialogContent, DialogTitle, Skeleton } from '@mui/material'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import SaveIcon from '@mui/icons-material/Save'
import { Input } from 'src/components/uiElements/fields/Input'
import { paymentServices } from 'src/services/payment/Payment.service'
import { useWatch } from 'react-hook-form'
import { DatePickers } from 'src/components/uiElements/react-hook-fields'
const isOptional = (optional) => {
  if (optional === undefined) return false
  if (optional && optional === true) return false
  return true
}

const getValidation = (field) => {
  const validation = []
  if (!field.optional) {
    validation.push(required())
  }
  return validation
}

const getInputProps = (field) => {
  const inputProps = {}

  if (field?.max_length) {
    inputProps.maxLength = field.max_length
  }

  return inputProps
}

const getOptionsBySearch = async (key, object_input_value, data, setIsLoading) => {
  if (Object.keys(object_input_value).length > 0) {
    if (
      object_input_value.hasOwnProperty('typeofselect') &&
      object_input_value.typeofselect.hasOwnProperty('search')
    ) {
      const { url, parameter } = object_input_value.typeofselect.search
      const choices = await getDataSelectBySearch(url, parameter, key, data, setIsLoading)
      object_input_value.choices = choices
    }
  }
}

const getDataSelectBySearch = async (url, parameter, key, data, setIsLoading) => {
  try {
    setIsLoading((current) => ({
      ...current,
      [key]: true,
    }))
    let choices = await getDataSelect(url, parameter, data)
    return choices
  } catch (error) {
  } finally {
    setIsLoading((current) => ({
      ...current,
      [key]: false,
    }))
  }
}

const replaceParameters = (url, parameters, data) => {
  if (parameters && Array.isArray(parameters) && parameters.length > 0) {
    let urlWithParam = url
    parameters.forEach((parameter) => {
      urlWithParam = urlWithParam.replace(`{${parameter}}`, data[parameter])
    })
    return urlWithParam
  }
}

const getDataSelect = async (url, parameter, data) => {
  // data should be have the "parameter" prop
  const urlWithParam = replaceParameters(url, parameter, data)
  try {
    const res = await paymentServices.getData(urlWithParam)
    return res
  } catch (error) {
    return []
  }
}

const DependInput = ({ elem, isLoading, setIsLoading, record, selectedBusinessUnit, selectedWorkUnit }) => {
  const translate = useTranslate()
  const selectedData = {
    work_unit_token: selectedWorkUnit?.token,
    work_unit_id: selectedWorkUnit?.id,
    hash_work_unit: selectedWorkUnit?.hash_work_unit,
    selectedWorkUnit: selectedWorkUnit,
    hash_business_unit: selectedBusinessUnit?.hash_business_unit,
    selectedBusinessUnit: selectedBusinessUnit,
  }
  const [key, value] = elem
  const { optional, type, depend, optionValue, optionText, ...props } = value
  const dependField = useWatch({ name: `${record?.source}.${depend?.field}` })

  useEffect(() => {
    if (dependField) {
      getOptionsBySearch(key, value, { [depend?.field]: dependField, ...selectedData }, setIsLoading)
    }
  }, [dependField])

  return (
    <>
      <EditInputsWrap
        label={translate(`ra.field.${props?.label_translate ? props?.label_translate : key}`)}
        required={isOptional(optional)}
      >
        {isLoading[key] ? (
          <Skeleton variant='rectangular' width={'100%'} height={40} />
        ) : (
          <Input
            type={type}
            optionText={optionText}
            optionValue={optionValue}
            source={`${record?.source}.${key}`}
            label={''}
            validate={getValidation(value)}
            inputProps={getInputProps(value)}
            fullWidth
            {...props}
          />
        )}
      </EditInputsWrap>
    </>
  )
}

export const ModalPayment = ({
  record,
  open,
  index,
  handleClose,
  selectedWorkUnit,
  selectedBusinessUnit,
  editableField = false,
  methods = null,
  onSubmit = null,
}) => {
  const translate = useTranslate()
  const [isLoading, setIsLoading] = useState({})
  const [config, setConfig] = useState(null)

  useEffect(() => {
    if (record?.[index] && record?.[index]?.config?.fields_to_interface) {
      transformConfig(record?.[index]?.config?.fields_to_interface)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [record, index])

  const transformConfig = async (fields_to_interface) => {
    Object.entries(fields_to_interface).forEach(async (elem) => {
      const [key, value] = elem
      const { type, typeofselect, depend, editable } = value
      if (editableField && !editable) return null

      if (type === 'select' && typeofselect && typeofselect.hasOwnProperty('fixed')) {
        const { options } = typeofselect.fixed
        value.choices = options
      } else if (type === 'select' && typeofselect && typeofselect.hasOwnProperty('search') && !depend) {
        const selectedData = {
          work_unit_token: selectedWorkUnit?.token,
          work_unit_id: selectedWorkUnit?.id,
          hash_work_unit: selectedWorkUnit?.hash_work_unit,
          selectedWorkUnit: selectedWorkUnit,
          hash_business_unit: selectedBusinessUnit?.hash_business_unit,
          selectedBusinessUnit: selectedBusinessUnit,
        }
        await getOptionsBySearch(key, value, selectedData, setIsLoading)
      }
    })
    setConfig((current) => ({
      ...current,
      [index]: fields_to_interface,
    }))
  }

  const getInputs = (config) => {
    return React.Children.toArray(
      Object.entries(config)?.map((elem) => {
        const [key, value] = elem
        const { optional, type, depend, optionValue, optionText, editable, ...props } = value
        if (editableField && !editable) return null
        return (
          <>
            {depend ? (
              <DependInput
                elem={elem}
                isLoading={isLoading}
                record={record?.[index]}
                setIsLoading={setIsLoading}
                selectedBusinessUnit={selectedBusinessUnit}
                selectedWorkUnit={selectedWorkUnit}
              />
            ) : (
              <EditInputsWrap
                label={translate(`ra.field.${props?.label_translate ? props?.label_translate : key}`)}
                required={isOptional(optional)}
              >
                {isLoading[key] ? (
                  <Skeleton variant='rectangular' width={'100%'} height={40} />
                ) : (
                  <Input
                    type={type}
                    optionText={optionText}
                    optionValue={optionValue}
                    source={`${record?.[index]?.source}.${key}`}
                    label={''}
                    validate={getValidation(value)}
                    inputProps={getInputProps(value)}
                    fullWidth
                    {...props}
                  />
                )}
              </EditInputsWrap>
            )}
          </>
        )
      })
    )
  }

  const handleSubmit = (data) => {
    handleClose()
    if (onSubmit) {
      onSubmit(data)
    }
    if (methods) {
      methods.reset()
    }
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleClose()
        methods && methods.reset()
      }}
      maxWidth='lg'
      fullWidth={true}
    >
      <DialogTitle>{translate('ra.message.configuration', { name: record?.[index]?.name })}</DialogTitle>
      {onSubmit && methods ? (
        <>
          <form onSubmit={methods.handleSubmit(handleSubmit)}>
            <DialogContent>
              <Grid container spacing={3}>
                <EditInputsWrap label={translate('ra.field.date')} required>
                  <DatePickers source={`date_time`} validate={[required()]} viewsShow={false} />
                </EditInputsWrap>
              </Grid>
              <Grid container spacing={3}>
                {config?.[index] && getInputs(config?.[index])}
              </Grid>

              <DialogActions className='dialog-actions'>
                <Button
                  onClick={() => {
                    handleClose()
                    methods.reset()
                  }}
                  variant='outlined'
                  color='error'
                >
                  {translate('ra.action.cancel')}
                </Button>
                <Button startIcon={<SaveIcon />} variant='contained' type='submit'>
                  {translate('ra.action.save')}
                </Button>
              </DialogActions>
            </DialogContent>
          </form>
        </>
      ) : (
        <>
          <DialogContent>
            <Grid container spacing={3}>
              {config?.[index] && getInputs(config?.[index])}
            </Grid>

            <DialogActions className='dialog-actions'>
              <Button onClick={handleClose} variant='outlined' color='error'>
                {translate('ra.action.cancel')}
              </Button>
              <Button
                startIcon={<SaveIcon />}
                variant='contained'
                type='submit'
                onClick={!onSubmit && handleSubmit}
              >
                {translate('ra.action.save')}
              </Button>
            </DialogActions>
          </DialogContent>
        </>
      )}
    </Dialog>
  )
}
